import {
	BackdropCircularProgress,
	DeleteConfirmationDialog,
	EnhancedButtonPrimeReact,
	EnhancedDialog,
	EnhancedDropDownRHFWithLabel,
	EnhancedSnackbar,
	IEnhancedDropDownItem,
	IResponse,
	IServerError,
	ITest,
	LabelPosition,
	RHookFormDatePicker,
	RHookFormTextFieldWithLabel,
	SingleColumnLayout,
	StandardPanel,
	StandardSubmitFormButtonsToolbar,
} from "@websential/cosmic-v20";
import {
	DATE_FORMAT_API_PAYLOAD,
	GET_QUERY_KEY,
	INITIAL_PAGE_SIZE,
	INITIAL_SNACKBAR_DATA,
	QUERY_OPTIONS,
	ROWS_PER_PAGE_PER_OPTIONS,
	TAX_PROFILE_SETUP_SCREEN_SLUG,
} from "../../../common/constants";
import { FC, useCallback, useEffect, useMemo, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { Grid, useTheme } from "@mui/material";
import { Link, useNavigate, useParams } from "react-router-dom";
import { formatDate, useNavigateToLogout } from "../../../common/Common";
import {
	setSelectedActivityLogActions,
	setSelectedStickyNavBar,
} from "../../../store/actions";
import { useDispatch, useSelector } from "react-redux";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { CountryService } from "../../../services/common/CountryService";
import { DDLDataTable } from "../../DDLDataTable";
import { IAppState } from "../../../store/reducers";
import { IGetListRequest } from "../../../models";
import { IProvinceReferenceModel } from "../../../models/province/IProvinceReferenceModel";
import { ITaxProfileSetupRequest } from "../../../models/taxProfileSetup";
import { ProvinceService } from "../../../services/common/ProvinceService";
import { TaxProfileService } from "../../../services/TaxProfileService";
import { TaxProfileSetupSchema } from "./validator";
import { TaxProfileSetupToolbar } from "./TaxProfileSetupToolbar";
import dayjs from "dayjs";
import { setSelectedDrawerOptionsMenu } from "../../../store/actions/drawerMenuOptionsActions";
import { yupResolver } from "@hookform/resolvers/yup";

// import { RHookFormDatePicker } from "../../RHookFormDatePicker";





export interface ITaxProfileSetup extends ITest { }
const TAX_PROFILE_LIST_QUERY_KEY: any = "tax-profile-list";

const useTaxProfiles = (
	params: IGetListRequest,
	navigateToLogout: (path: string) => void
) =>
	useQuery({
		queryKey: ["tax-profile-list", params],
		queryFn: (data) => {
			return TaxProfileService.getList(params, navigateToLogout);
		},
		refetchOnWindowFocus: false,
	});
// const useGetProvinceDDL = () => {
// 	return useQuery({
// 		queryKey: [GET_QUERY_KEY.PROVINCE_DDL],
// 		queryFn: () => ProvinceService.getOld(),
// 		...QUERY_OPTIONS,
// 	});
// };

const useGetById = (id: string | undefined) =>
	useQuery({
		queryKey: [GET_QUERY_KEY.GET_TAX_PROFILE_BY_ID, id],
		queryFn: (data) => {
			return TaxProfileService.getById(id);
		},
		refetchOnWindowFocus: false,
	});

const useGetCountryDDL = () =>
	useQuery({
		queryKey: ["country-ddl"],
		queryFn: () => CountryService.getCountryDDL(),
		refetchOnWindowFocus: false,
	});

export const TaxProfileSetup: FC<ITaxProfileSetup> = ({ testId }) => {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const theme = useTheme();
	const navigateToLogout = useNavigateToLogout();
	const queryClient = useQueryClient();

	const [snackbarData, setSnackbarData] = useState(INITIAL_SNACKBAR_DATA);
	const drawerMenuOptions = useSelector(
		(state: IAppState) => state.drawerMenu.menu
	);
	const [openDialog, setDialogOpen] = useState(false);
	const [openArchiveDialog, setArchiveDialogOpen] = useState(false);
	const [singleDelete, setSingleDelete] = useState<boolean>(false);
	const [singleArchive, setSingleArchive] = useState<boolean>(false);
	const [taxProfileId, setTaxProfileId] = useState<any>(0);

	// const [selectedProvince, setSelectedProvince] =
	// 	useState<IProvinceReferenceModel>({
	// 		id: null,
	// 		name: "",
	// 		shortCode: "",
	// 	});
	const { id } = useParams();
	const [editRecordId, setEditRecordId] = useState(id);
	const [provinceDDL, setProvinceDDL] =
		useState<any>(undefined);
	const [queryParams, setQueryParams] = useState<IGetListRequest>({
		search_query: "",
		order_by: "taxLabel",
		order_direction: "asc",
		page: 1,
		size: 25,
	});

	const onRequestParamsChange = useCallback((requestParams: any) => {
		let dispatchParams = {
			search_query: requestParams.searchQuery ? requestParams.searchQuery : "",
			order_by:
				requestParams.sortField !== null ? requestParams.sortField : "taxLabel",
			order_direction: requestParams.sortOrder
				? requestParams.sortOrder
				: "asc",
			page: requestParams.page + 1,
			size: requestParams.rows,
		};

		setQueryParams(dispatchParams);
	}, []);

	const { isPending: isPendingCountryDDL, data: countryList } =
		useGetCountryDDL();

	useEffect(() => {
		if (countryList && Array.isArray(countryList)) {
			const canada = countryList.find(
				(item: any) => item.label === "Canada" || "canada"
			);
			if (canada) {
				(async () => {
					try {
						const response = await CountryService.getProvinceOrStateDDL(
							navigateToLogout,
							canada.value,
							"Province"
						);
						setProvinceDDL(response);
					} catch (err) {
						console.error("error", err);
					}
				})();
			} else {
				setProvinceDDL(undefined);
			}
		}
	}, [countryList]);

	console.log("countryListttt", countryList)
	console.log("provincesDDL", provinceDDL)

	const { isPending, data } = useTaxProfiles(queryParams, navigateToLogout); //useQuery('accountants-list', AccountantService.getAccountantList, { refetchOnWindowFocus: false });
	const taxProfileList: any = data;

	const upadtedTaxProfileListItems = useMemo(() => {
		return (
			taxProfileList &&
			taxProfileList.items &&
			taxProfileList?.items.map((item: any) => ({
				...item,
				label: (
					<Link
						to={`/tax-profile/setup/${item.id}`}
						className="no-underline"
						style={{ color: theme.palette.primary.light }}
						onClick={() => setEditRecordId(item.id)}
					>
						{item.taxLabel}
					</Link>
				),
			}))
		);
	}, [taxProfileList]);

	const DEFAULT_VALUES = {
		province: undefined,
		effectiveDate: null,
		expiryDate: null,
		taxLabel: undefined,
		taxPercent: undefined,
	};
	const formMethods = useForm<any>({
		resolver: yupResolver(TaxProfileSetupSchema),
		mode: "onBlur",
		reValidateMode: "onChange",
		defaultValues: DEFAULT_VALUES
	});

	const { isPending: isSubmitting, mutate: submitFormData } = useMutation({
		mutationFn: TaxProfileService.create,
		onSuccess: (res: any) => {
			let message = "Not a valid response message from API";
			if (res.success) {
				message = String(res.message);
				setEditRecordId(res.data.id);
			} else {
				message = String(res.data.message);
			}

			setSnackbarData({
				open: true,
				message: message,
				severity: res.success ? "success" : "error",
			});
			let path = `/tax-profile/setup/${res.data.id}`;
			navigate(path);
			return Promise.all([
				queryClient.invalidateQueries({
					queryKey: [TAX_PROFILE_LIST_QUERY_KEY],
				}),
				queryClient.invalidateQueries({
					queryKey: [GET_QUERY_KEY.GET_TAX_PROFILE_BY_ID],
				}),
			]);
		},
		onError: (err) => {
			// TODO: customize the toast message based on the response
			setSnackbarData({
				open: true,
				message: "Something went wrong, try again later!",
				severity: "error",
			});
		},
	});

	// const { isPending: isPendingProvinceDropDownList, data: provinceList } =
	// 	useGetProvinceDDL();



	const { isPending: isPendingEditData, data: editDataRecord } =
		useGetById(editRecordId);

	const onSubmit = (formData: any) => {

		const selectedProvinceOrState = formData.province
			? provinceDDL.find((e: any) => e.value === formData.province)
			: formData.state
				? provinceDDL.find((e: any) => e.value === formData.state)
				: undefined;

		const requestPayload = {
			id: id && id,
			province:
			{
				id: selectedProvinceOrState.value,
				name: selectedProvinceOrState.label,
				shortCode: selectedProvinceOrState.shortCode,
			},

			// province: selectedProvince,
			effectiveDate: formatDate(formData.effectiveDate),
			expiryDate: formatDate(formData.expiryDate),
			taxLabel: formData.taxLabel,
			taxPercent: formData.taxPercent,
		};
		submitFormData(requestPayload);
		console.log("payload", requestPayload)
	};

	const { isPending: isDeleting, mutate: deleteTaxProfileSetupById } =
		useMutation({
			mutationFn: TaxProfileService.delTaxProfile,
			onSuccess: (res: string | IServerError | IResponse) => {
				if (typeof res === "string") {
					// remove the cache of the TaxProfileSetup fields since we just added a new field.
					setSnackbarData({
						open: true,
						message: "Success",
						severity: "success",
					});
				} else {
					setSnackbarData({
						open: true,
						message: "Something went wrong, try again later!",
						severity: "error",
					});
				}
				formMethods.reset();
				let path = `/tax-profile/setup`;
				navigate(path);
				return queryClient.invalidateQueries({
					queryKey: [TAX_PROFILE_LIST_QUERY_KEY],
				});
			},
			onError: (err) => {
				// TODO: customize the toast message based on the response
				setSnackbarData({
					open: true,
					message: "Something went wrong, try again later!",
					severity: "error",
				});
			},
		});

	const deleteTaxProfileSetupField = () => {
		if (singleDelete) {
			setSingleDelete(false);
			let delPayload = {
				taxProfileId: taxProfileId,
				navigateToLogout: navigateToLogout,
			};
			deleteTaxProfileSetupById(delPayload);
			setDialogOpen(false);
		}
	};

	const onDeleteClicked = () => {
		setDialogOpen(true);
		setSingleDelete(true);
		if (editDataRecord) {
			setTaxProfileId(editDataRecord.id);
		}
	};

	const onRowDeleteClicked = useCallback((params: any) => {
		setDialogOpen(true);
		setSingleDelete(true);
		setTaxProfileId(params.id);
	}, []);

	const { isPending: isArchive, mutate: archiveTaxProfileById } = useMutation({
		mutationFn: TaxProfileService.archiveTaxProfile,

		onSuccess: (res: string | IServerError | IResponse) => {
			if (typeof res === "string") {
				// remove the cache of the TaxProfile fields since we just added a new field.
				setSnackbarData({
					open: true,
					message: "Success",
					severity: "success",
				});
			} else {
				setSnackbarData({
					open: true,
					message: "Something went wrong, try again later!",
					severity: "error",
				});
			}
			formMethods.reset();
			let path = `/tax-profile/setup`;
			navigate(path);
			return queryClient.invalidateQueries({
				queryKey: [TAX_PROFILE_LIST_QUERY_KEY],
			});
		},
		onError: () => {
			// TODO: customize the toast message based on the response
			setSnackbarData({
				open: true,
				message: "Something went wrong, try again later!",
				severity: "error",
			});
		},
	});

	const archiveTaxProfileField = () => {
		if (singleArchive) {
			setSingleArchive(false);
			let ArchivePayload = {
				taxProfileId: taxProfileId,
				navigateToLogout: navigateToLogout,
			};
			archiveTaxProfileById(ArchivePayload);
			setArchiveDialogOpen(false);
		}
	};

	const onArchiveClicked = () => {
		setArchiveDialogOpen(true);
		setSingleArchive(true);
		if (editDataRecord) {
			setTaxProfileId(editDataRecord.id);
		}
	};

	const onCloseHandler = () => {
		setDialogOpen(false);
	};
	const onCloseArchiveHandler = () => {
		setArchiveDialogOpen(false);
	};

	const onRowEditClicked = useCallback((params: any) => {
		// alert(`Edit row with ID: ${params.row.id} has been clicked!`);
		let path = `/tax-profile/setup/${params.value}`;
		navigate(path);
	}, []);

	const onResetClicked = () => {
		setSnackbarData({
			open: true,
			message: "Success",
			severity: "success",
		});
		formMethods.reset();
		let path = `/tax-profile/setup`;
		navigate(path);
	};

	const onSnackbarClosed = (
		event: React.SyntheticEvent | Event,
		reason?: string
	) => {
		if (reason === "clickaway") {
			return;
		}
		setSnackbarData(INITIAL_SNACKBAR_DATA);
	};

	// const onProvinceSelectionChangeHandler = (item: IEnhancedDropDownItem) => {
	// 	setSelectedProvince({
	// 		id: item.id,
	// 		name: item.label,
	// 		shortCode: String(item.value),
	// 	});
	// };

	// for edit
	useEffect(() => {
		// if the selected flex field data has loaded.
		if (editDataRecord) {
			Object.keys(editDataRecord).forEach((fieldName) => {

				// @ts-ignore
				const fieldValue = editDataRecord[fieldName];

				// @ts-ignore
				// formMethods.setValue(fieldName, fieldValue ?? undefined);
				if (typeof fieldValue !== "object") {
					// @ts-ignore
					formMethods.setValue(fieldName, fieldValue ?? undefined);
					if (fieldName === "effectiveDate") {
						formMethods.setValue(fieldName, new Date(fieldValue) ?? undefined);
					}
					if (fieldName === "expiryDate") {
						formMethods.setValue(fieldName, new Date(fieldValue) ?? undefined);
					}
					if (fieldName === "province") {
						formMethods.setValue(fieldName, new Date(fieldValue) ?? undefined);
					}
				}
				else if (fieldValue !== null || undefined) {
					// @ts-ignore
					// @ts-ignore
					if (fieldName === "province") {
						formMethods.setValue(fieldName, fieldValue.id ?? undefined);
					} else {
						formMethods.setValue(fieldName, fieldValue.shortCode ?? undefined);
					}

				}
			});
		}
	}, [editDataRecord, formMethods.setValue, formMethods]);

	const expandedLabels = ["Misc.", "Tax Profile"];
	const expandedTaxProfileSetupItem = "Tax Profile";
	const enhanceData = (data: any[], parentLabel?: string): any[] => {
		return data.map((item) => {
			let isExpanded = expandedLabels.includes(item.label);
			if (
				parentLabel === "Misc." &&
				item.label === expandedTaxProfileSetupItem
			) {
				isExpanded = true;
			}
			const enhancedItem = {
				...item,
				expanded: item.items ? isExpanded : false,
				items: item.items ? enhanceData(item.items, item.label) : undefined,
				path: item.label === expandedTaxProfileSetupItem && "/tax-profile/setup",
			};
			return enhancedItem;
		});
	};

	useEffect(() => {
		dispatch(
			setSelectedActivityLogActions({
				entityId1: "",
				entityId2: "",
				entityId3: "",
				screenName: TAX_PROFILE_SETUP_SCREEN_SLUG,
				companyName: "",
				activityType: "activity_type=create&activity_type=updated",
				activityLogVisibility: true,
			})
		);
		dispatch(setSelectedStickyNavBar({ isSticky: true }));
		if (drawerMenuOptions && drawerMenuOptions.length > 0) {
			const enhancedData = enhanceData(drawerMenuOptions);
			dispatch(setSelectedDrawerOptionsMenu({ menu: enhancedData }));
		}
	}, [drawerMenuOptions]);

	return (
		<Grid
			size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
		// sx={{ "& .MuiAppBar-root": { zIndex: 2, top: "65px" } }}
		>
			<BackdropCircularProgress
				open={
					// isPendingProvinceDropDownList ||
					isPendingCountryDDL ||
					isSubmitting ||
					isPendingEditData ||
					isDeleting ||
					isArchive
				}
				testId={testId}
			/>
			<DeleteConfirmationDialog
				open={openDialog}
				deleteActionHandler={deleteTaxProfileSetupField}
				cancelActionHandler={onCloseHandler}
				testId="accountant-confirmation-dialog"
			/>
			<FormProvider {...formMethods}>
				<form onSubmit={formMethods.handleSubmit(onSubmit)}>
					<Grid container size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
						<Grid size={{ xs: 12, sm: 12, md: 3.5, lg: 3.5, xl: 3.5 }}>
							<SingleColumnLayout
								toolbar={
									<TaxProfileSetupToolbar
										onResetClicked={onResetClicked}
										onDeleteClicked={onDeleteClicked}
										isSubmitting={false}
										id={id}
									/>
								}
								children={
									<StandardPanel
										title="Add Tax Profile"
										testId="tax-profile-setup-panel"
										showTitle={false}
										variant="outlined"
										topPadding={2}
									>
										<EnhancedDropDownRHFWithLabel
											selectName="province"
											label="Province"
											// selectedItem={selectedProvince.shortCode}
											labelPosition={LabelPosition.Top}
											required
											testId={"tax-profile-province-list"}
											items={provinceDDL ?? []}
										// onSelectionChangeHandler={onProvinceChangeHandler}
										// items={provinceList ?? []}
										// onSelectionChangeHandler={
										// 	onProvinceSelectionChangeHandler
										// }
										/>
										<RHookFormDatePicker
											name="effectiveDate"
											testId="Effective Date"
											label="Effective-Date"
											labelPosition={LabelPosition.Top}
											format="M dd, yy"
											required
											labelColumns={4}
											fieldColumns={8}
										/>
										<RHookFormDatePicker
											name="expiryDate"
											testId="Expiry Date"
											label="Expiry-Date"
											labelPosition={LabelPosition.Top}
											format="M dd, yy"
											// required
											labelColumns={4}
											fieldColumns={8}
										/>
										<RHookFormTextFieldWithLabel
											id="taxLabel"
											testId={`${testId}-tax-label`}
											label="Tax Label"
											required
											labelPosition={LabelPosition.Top}
										/>
										<RHookFormTextFieldWithLabel
											id="taxPercent"
											testId={`${testId}-tax-percentage`}
											label="Tax %"
											required
											labelPosition={LabelPosition.Top}
										/>
									</StandardPanel>
								}
								testId="tax-profile-setup-grid"
								showFullDiaplay={true}
								toolbarPosition="bottom"
							/>
						</Grid>
						<Grid size={{ xs: 0, sm: 0, md: 4, lg: 4, xl: 4 }}></Grid>
						<Grid
							size={{ xs: 12, sm: 12, md: 4.5, lg: 4.5, xl: 4.5 }}
							sx={{ marginTop: "16px" }}
						>
							<DDLDataTable
								rows={
									taxProfileList && upadtedTaxProfileListItems
										? upadtedTaxProfileListItems
										: []
								}
								columns={[
									{ field: "label", headerName: "Tax Label" },
									{ field: "province", headerName: "Province" },
									{ field: "taxPercent", headerName: "Tax %" },
								]}
								showHeaderColumns={true}
								onRowEditClicked={onRowEditClicked}
								onRowDeleteClicked={onRowDeleteClicked}
								onRowArchiveClicked={onArchiveClicked}
								isLoading={isPending}
								totalRecords={
									taxProfileList && taxProfileList.total
										? taxProfileList.total
										: 0
								}
								initialPageSize={INITIAL_PAGE_SIZE}
								rowsPerPageOptions={ROWS_PER_PAGE_PER_OPTIONS}
								onRequestParamsChange={onRequestParamsChange}
								tableScrollHeight={"60vh"}
								selectedId={taxProfileList && id && taxProfileList.id}
							/>
						</Grid>
						<Grid size={{ xs: 0, sm: 0, md: 0, lg: 1, xl: 1 }}></Grid>
					</Grid>
				</form>
			</FormProvider>

			{/* Archive Dialogue */}
			<EnhancedDialog
				dialogTitle="Please Confirm"
				key="dialog-box"
				testId="dialog"
				onCloseHandler={onCloseArchiveHandler}
				open={openArchiveDialog}
				dialogContent={null}
				showdividers={false}
				dialogAction={
					<Grid>
						<EnhancedButtonPrimeReact
							label="Cancel"
							severity="secondary"
							text
							raised
							onClickHandler={onCloseArchiveHandler}
							style={{ fontSize: "small" }}
						/>
						<EnhancedButtonPrimeReact
							label="Archive"
							severity="secondary"
							raised
							onClickHandler={() => archiveTaxProfileField}
							style={{ marginLeft: "16px", fontSize: "small" }}
						/>
					</Grid>
				}
			/>

			<EnhancedSnackbar
				message={snackbarData.message}
				onCloseHandler={onSnackbarClosed}
				severity={snackbarData.severity}
				testId={`${testId}-snackbar`}
				open={snackbarData.open}
			/>
		</Grid>
	);
};
